import * as React from 'react';
import * as styles from './style.css';
import { UIHeading5 } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const ComparisonControl = _ref => {
  let {
    url,
    handleLinkClick,
    handleClose
  } = _ref;
  if (url) {
    return /*#__PURE__*/_jsx(UIHeading5, {
      color: "text-inverted-default",
      children: /*#__PURE__*/_jsx("a", {
        href: url,
        className: styles['link'],
        onClick: handleLinkClick,
        target: "_blank",
        rel: "noreferrer",
        children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438"
      })
    });
  }
  return /*#__PURE__*/_jsx(UIHeading5, {
    color: "text-inverted-default",
    children: /*#__PURE__*/_jsx("button", {
      onClick: handleClose,
      className: styles['button'],
      children: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E"
    })
  });
};